import React from "react";
import Navbar from "./layout/navbar";
import Footer from "./layout/footer";

export default function Layout({ children, cartCount = 0 }) {
  return (
    <div className="min-h-screen bg-[#fbf7f1] text-black/90">
      <Navbar cartCount={cartCount} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
